import { useState } from 'react';

import { gql, useQuery } from '@apollo/client';

export const GET_COMPANIES_WITH_JOBS = gql`
  query getAllPlatformCompaniesWithPagination($queryOptions: QueryOptionsInput!) {
    getAllPlatformCompaniesWithPagination(queryOptions: $queryOptions) {
      collection {
        _id
        name
        departments {
          _id
          name
          jobLocations {
            _id
            job {
              _id
              createdBy
              title
            }
            jobSupervisors {
              _id
              jobPlacesCount
              assignedMembers {
                _id
                profile {
                  displayName
                  avatarUrl
                }
              }
            }
          }
        }
      }
      totalCount
    }
  }
`;

export const useGetCompaniesWithJobs = () => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>([]);
  const pageSize = 12;
  const { data, loading } = useQuery(GET_COMPANIES_WITH_JOBS, {
    variables: {
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
    },
    fetchPolicy: 'network-only',
  });
  const { collection = [], totalCount = 0 } = data?.getAllPlatformCompaniesWithPagination || {};

  return {
    loading,
    companies: collection,
    onTableChange: (a: any, b: any, { order }: any) => {
      const sortArray = [];

      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        sortArray.push({ field: 'name', sortBy });
      }

      setNameSort(sortArray);
    },
    paginationConfig: {
      pageSize,
      total: totalCount,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
  };
};
